import { DEFAULT_MESSAGE_AFTER_CONNECTION_FILTER } from 'constants/common'
import { replaceValueAtPath } from 'helpers/utils'
import MessageAfterConnection from 'store/actionTypes/messageAfterConnection'
import UserTypes from '../actionTypes/user'

const initialData = {
  list: [],
  current: {},
  filter: DEFAULT_MESSAGE_AFTER_CONNECTION_FILTER,
  pagination: {}
}

const messageAfterConnection = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case MessageAfterConnection.GET_MESSAGE_AFTER_CONNECTIONS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case MessageAfterConnection.GET_MESSAGE_AFTER_CONNECTION_DETAIL_SUCCESS:
      return replaceValueAtPath(state, 'current', payload)
    case MessageAfterConnection.UPDATE_MESSAGE_AFTER_CONNECTION_FILTER_SUCCESS:
      return replaceValueAtPath(state, 'filter', payload)
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default messageAfterConnection
